import { __dispatchEvent, __globalPosition } from '../../lib/utils';

// Static SVG utilities extracted from svg.js to avoid circular deps
export default class SVGUtils {
  // Mark element as selected
  static selectItem(item) {
    item.setAttribute('data-svg-selected', 'true');
  }

  // Remove 'selected' marker from all selected elements
  static deselectItem() {
    const selected = document.querySelectorAll('[data-svg-selected="true"]');
    for (let i = 0; i < selected.length; i += 1) {
      selected[i].setAttribute('data-svg-selected', 'false');
    }
  }

  // Remove element from SVG and dispatch change/drop events
  static removeItem(isRadial, element = '[data-svg-selected="true"]') {
    let $element = document.querySelector(element);
    let nodeName = $element.nodeName;
    const $parent = $element.parentElement; // for <foreignObject>

    switch (nodeName) {
      case 'path':
      case 'circle':
      case 'TEXTAREA':
        break;
      case 'DIV':
        if ($parent.getAttribute('data-svg-type') === 'pretahovani') {
          $element = $parent;
        } else {
          $element = $parent.childNodes[0];
        }
        nodeName = $element.nodeName;
        break;
      default:
        console.log('Nondefinated node type. :(', nodeName);
    }

    const svgID = $element.id.split('_')[0];

    __dispatchEvent(
      document,
      'svg.change',
      {},
      {
        svg: {
          id: svgID,
          task: 'remove',
          node: $element,
          nodeName,
          contextMenu: isRadial,
        },
      },
    );

    if ($parent.nodeName === 'foreignObject') {
      const elemIdParts = $element.id.split('_');
      d3.select(`[id^="${elemIdParts[0]}_${elemIdParts[1]}-circle"`).remove();

      d3.select($parent).remove();

      const idParts = $parent.id.split('_');
      const $slide = document.querySelector(`#${svgID}`).closest('.slide');
      if (idParts[idParts.length - 1] === 'dropItem') {
        __dispatchEvent(
          document,
          'svg.drop.delete',
          {},
          {
            item: {
              slideId: $slide.id,
              id: idParts[1],
              $object: $element.firstChild,
            },
          },
        );
      }
    } else {
      d3.select($element).remove();
    }
  }

  // Unmark all SVGs with 'svg-active'
  static deactivate() {
    const allActiveSvgs = document.querySelectorAll('[data-svg-active="true"]');
    for (let i = 0; i < allActiveSvgs.length; i += 1) {
      allActiveSvgs[i].setAttribute('data-svg-active', 'false');
    }
  }

  // Mark active SVG with 'svg-active'
  static activate(svg) {
    SVGUtils.deactivate();
    svg.setAttribute('data-svg-active', 'true');
  }

  // Remove connection between clone and template
  static removeCloneConnectionManager($node) {
    const idParts = $node.id.split('_');
    if (idParts[idParts.length - 1].includes('clone')) {
      idParts.pop();
      $node.id = idParts.join('_');
      // Remove the clone attribute when the clone connection is removed
      $node.removeAttribute('data-svg-clone');
      return true;
    }
    return false;
  }

  // Find near elements if exist
  static findNearElements(event) {
    let $element = event.target;
    const relativeCoords = [
      [-3, -3],
      [0, -5],
      [3, -3],
      [-5, 0],
      [5, 0],
      [-3, 3],
      [0, 5],
      [3, 3],
    ];

    if ($element.nodeName === 'image' || $element.nodeName === 'svg') {
      relativeCoords.every((coord) => {
        const globalPosition = __globalPosition(event);
        const $nextElement = document.elementFromPoint(
          globalPosition.x + coord[0],
          globalPosition.y + coord[1],
        );

        if (
          !$nextElement ||
          $nextElement.nodeName === 'DIV' ||
          $nextElement.nodeName === 'svg'
        ) {
          return true;
        }

        $element = $nextElement;
        return $element.nodeName === 'image';
      });
    }

    return $element;
  }
}
